import Vue from 'vue'
import Dialog from '@/components/dialog/dialog.vue'

// 全局挂载一个 Dialog 实例，通过 this.$confirm / this.$alert 调用，
// 返回 Promise<boolean>，用法上与原生 confirm()/alert() 基本一致，
// 但不依赖浏览器原生弹窗（规避 iOS WKWebView 下的兼容性问题）。
const DialogConstructor = Vue.extend(Dialog)
let instance = null

function getInstance() {
  if (!instance) {
    instance = new DialogConstructor()
    instance.$mount()
    document.body.appendChild(instance.$el)
  }
  return instance
}

Vue.prototype.$confirm = function (message, options = {}) {
  const dialog = getInstance()
  return dialog.open({
    message,
    title: options.title || '',
    confirmText: options.confirmText || '确定',
    cancelText: options.cancelText || '取消',
    showCancel: true
  })
}

Vue.prototype.$alert = function (message, options = {}) {
  const dialog = getInstance()
  return dialog.open({
    message,
    title: options.title || '',
    confirmText: options.confirmText || '确定',
    showCancel: false
  })
}
